import { render, staticRenderFns } from "./AddQuestionModal.vue?vue&type=template&id=8d86e26c&scoped=true&"
import script from "./AddQuestionModal.vue?vue&type=script&lang=js&"
export * from "./AddQuestionModal.vue?vue&type=script&lang=js&"
import style0 from "./AddQuestionModal.vue?vue&type=style&index=0&id=8d86e26c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d86e26c",
  null
  
)

export default component.exports